interface RestProps { }

export default function SmartImageLoader({ imageURL, types, alt, fallback, ...restProps }: { imageURL: string, types: string[], alt: string, fallback: string, style: Object } & RestProps) {
    return (
        <picture {...restProps}>
            {types.map((type, index) => (
                <source key={index} srcSet={`${imageURL}.${type}`} type={`image/${type}`} />
            ))}
            <img src={`${imageURL}.${fallback}`} alt={alt} {...restProps} />
        </picture>
    );
}

